// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__sAhAc","spin":"Spinner_spin__FIC4U"};